const VISTA_API_URL =
  process.env.REACT_APP_VISTA_API_URL ||
  "http://127.0.0.1:5001/soundvista/us-central1/vistaChat";

export async function sendVistaMessage(messages) {
  try {
    const res = await fetch(VISTA_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages }),
    });
    const data = await res.json();
    if (data.error) throw new Error(data.error);
    return data.reply;
  } catch (err) {
    console.error("Vista AI error:", err);
    return "Vista is taking a moment. Try again shortly.";
  }
}
